import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";
export const getBankAccounts = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.get(`/bank-accounts${formatPayloadToQueryString(payload)}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar contas bancárias', error);
        throw error;
    }
};
export const createBankAccount = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/bank-accounts', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao criar conta bancária', error);
        throw error;
    }
};
export const updateBankAccount = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.put(`/bank-accounts/${payload.id}`, payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao atualizar conta bancária', error);
        throw error;
    }
};
export const deleteBankAccount = async (bankAccountId, userToken) => {
    try {
        await CoursesApiService.delete(`/bank-accounts/${bankAccountId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    }
    catch (error) {
        console.error('Erro ao deletar conta bancária', error);
        throw error;
    }
};
export const toggleBankAccountActive = async (bankAccountId, userToken) => {
    try {
        const response = await CoursesApiService.post(`/bank-accounts/${bankAccountId}/toggle-active`, {}, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao alterar status da conta bancária', error);
        throw error;
    }
};
export default {
    getBankAccounts,
    createBankAccount,
    updateBankAccount,
    deleteBankAccount,
    toggleBankAccountActive
};
